<script>
import VcBottomSheet from '../VcBottomSheet/VcBottomSheet.vue';

export default {
  name: 'VcMenu',
  props: {
    dataQa: {
      type: String,
      default: 'VcMenu',
    },
  },
  render: function (createElement) {
    const props = {
      ...this.$props,
      ...this.$attrs,
    };

    return createElement(this.$vuetify.breakpoint.mdAndUp ? 'v-menu' : VcBottomSheet, {
      props,
      on: this.$listeners,
      scopedSlots: this.$scopedSlots,
    });
  },
};
</script>

<style lang="scss" scoped></style>
